import axios from 'axios';

/**
 * 直播详情信息
 * @returns {*}
 */
export function liveDetailAccessApi(id, payload = {}) {
    // payload = payload || {};
    const url = `/live/new/front/${id}`;
    return axios.get(url, { params: payload, loading: true });
}

/**
 * 直播详情信息2
 * @returns {*}
 */
export function liveDetailApi(id) {
    const url = `/live/new/${id}`;
    return axios.get(url, {
        loading: true,
        // isCache: true,
        // isStorage: 'localStorage',
        // isExpired: 2 * 60
    });
}

/**
 * 直播详情信息3
 * @returns {*}
 */
export function liveDetailNoAccessApi(id) {
    const url = `/live/new/detail/${id}`;
    return axios.get(url, {
        loading: true,
        // isCache: true,
        // isStorage: 'localStorage',
        // isExpired: 2 * 60,
    });
}

/**
 * 直播预览详情
 * @returns {*}
 */
export function liveDetailPreviewApi(id) {
    const url = `/live/new/${id}`;
    return axios.get(url, { loading: true });
}

/**
 * 直播评分
 * @returns {*}
 */
export function doScoreApi(payload) {
    const url = '/course-study/course-front/score';
    return axios.post(url, payload, { encode: true });
}

/**
 * 收藏
 * @returns {*}
 */
export function collectApi(payload) {
    return axios.post('/system/collect', payload, { encode: true });
}

/**
 * 取消收藏
 * @returns {*}
 */
export function cancelCollectApi(id) {
    const url = `/system/collect/${id}`;
    return axios.delete(url, { id, encode: true }, { encode: true });
}

/**
 * 获取收藏信息
 * @returns {*}
 */
export function getCollectApi(payload) {
    return axios.get('/system/collect', {
        params: payload,
        loading: true
    });
}

/**
 * 获取直播讲师列表
 * @returns {*}
 */
export function getTeacherListApi(payload) {
    return axios.get('/course-study/gensee-student/relative-members', { params: payload });
}

/**
 * 查询直播预约状态
 * @returns {*}
 */
export function getLiveAppointmentApi(id) {
    const url = `/live/new/front/sub-status/${id}`;
    return axios.get(url);
}

/**
 * 直播预约
 * @returns {*}
 */
export function liveSubApi(payload) {
    return axios.post('/live/new/front/sub', payload, { encode: true });
}

/**
 * 取消直播预约
 * @returns {*}
 */
export function cancelLiveSubApi(payload) {
    return axios.post('/live/new/front/cancel-sub', payload, { encode: true });
}

/**
 * 获取观看直播地址
 * @returns {*}
 */
export function getLookLiveUrlApi(id, payload) {
    const url = `/live/new/enter-url/${id}`;
    return axios.get(url, { params: payload, loading: true });
}

/**
 * 获取直播access
 * @returns {*}
 */
export function getLiveAccess(id) {
    const url = `/live/new/front/access/${id}`;
    return axios.post(url);
}

/**
 * 获取发起直播地址
 * @returns {*}
 */
export function getAnchorLiveUrlApi(id) {
    const url = `/live/new/start/${id}`;
    return axios.get(url);
}

/**
 * 获取观看直播人数
 * @returns {*}
 */
export function getUserJoinCountDistinctApi(payload) {
    const url = '/live/new/history-count';
    return axios.get(url, {
        params: payload,
        loading: true,
        isCache: true,
        isStorage: 'localStorage',
        isExpired: 2 * 60
    })
        .then(res => res.data);
}

/**
 * 获取加入直播地址
 * @returns {*}
 */
export function getJoinLiveUrlApi(id, payload) {
    const url = `/live/new/temp-url/${id}`;
    return axios.get(url, {
        params: payload,
        loading: true,
        // isCache: true,
        // isStorage: 'localStorage',
        // isExpired: 2 * 60
    });
}

/**
 * 获取开播连接
 * @returns {*}
 */
export function getEnterLiveUrl(id, payload) {
    const url = `/live/new/enter/${id}`;
    return axios.get(url, { params: payload, loading: true });
}

export function getCompanyById(payload) {
    const url = '/system/company-sync/get-company-by-id';
    return axios.get(url, { params: payload, loading: true });
}

export function getInterestedItem(payload) {
    return axios
        .get('/live/new/relative-members', { params: payload })
        .then(res => res.data);
}

export function getGenseeStudentBusiness(id, payload) {
    return axios
        .get(`/course-study/gensee-student/business/${id}`, { params: payload })
        .then(res => res.data);
}

export function getExamByIds(payload) {
    return axios
        .get('/exam/exam/basic-by-ids', { params: payload })
        .then(res => res.data);
}

export function newLiveUserScoreApi(id, payload) {
    return axios
        .get(`/live/score/${id}`, { params: payload })
        .then(res => res.data);
}

export function newLiveUserSetScoreApi(payload) {
    return axios
        .post('/live/score', payload, { encode: true })
        .then(res => res.data);
}
